import http from "./controllerFetch";

class ordiniService {

  get( params = {}) {
    return http.get('ordini/read', { params });
  }

  getAll( params = {}) {
    return http.get('ordini/search', { params });
  }

  create(data) {
    return http.post('ordini/crea', data);
  }

}

export default new ordiniService();